// extracted by mini-css-extract-plugin
export var root = "Banner-module--root--37JVE";
export var fullScreen = "Banner-module--fullScreen--15J2g";
export var logo = "Banner-module--logo--aSGgZ";
export var logoScrolled = "Banner-module--logoScrolled--1a8q8";